var _excluded = ["onChange", "options", "defaultValue", "selectProps", "value", "withSuffixIcon", "placeholder", "onSearch"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useMemo } from 'react';
import { Select, Input } from '@osui/ui';
import { useDerivedState } from 'huse';
import cs from 'classnames';
import './index.less';
import { jsx as _jsx } from "react/jsx-runtime";
var emptyArray = [undefined, undefined];

function GroupInput(_ref) {
  var onChange = _ref.onChange,
      options = _ref.options,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? emptyArray : _ref$defaultValue,
      _ref$selectProps = _ref.selectProps,
      selectProps = _ref$selectProps === void 0 ? {
    style: {
      width: 100
    }
  } : _ref$selectProps,
      valueIn = _ref.value,
      withSuffixIcon = _ref.withSuffixIcon,
      placeholderIn = _ref.placeholder,
      onSearch = _ref.onSearch,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useDerivedState = useDerivedState(valueIn || defaultValue),
      _useDerivedState2 = _slicedToArray(_useDerivedState, 2),
      value = _useDerivedState2[0],
      setValue = _useDerivedState2[1];

  var onInputChange = useCallback(function (e) {
    var newValue = [value ? value[0] : undefined, e.target.value];
    setValue(newValue);
    onChange && onChange(newValue);
  }, [value, onChange, setValue]);
  var placeholder = useMemo(function () {
    if (value[0]) {
      var _options$find;

      var label = options === null || options === void 0 ? void 0 : (_options$find = options.find(function (i) {
        return (i === null || i === void 0 ? void 0 : i.value) === value[0];
      })) === null || _options$find === void 0 ? void 0 : _options$find.label;
      return "\u8F93\u5165".concat(label, "\u5173\u952E\u5B57\u641C\u7D22");
    }

    return '请输入';
  }, [options, value]);
  var onSelectChange = useCallback(function (v) {
    var newValue = [v, value ? value[1] : undefined];
    setValue(newValue);
    onChange && onChange(newValue);
  }, [value, onChange, setValue]);
  var onInputSearch = useCallback(function (v) {
    var newValue = [value ? value[0] : undefined, v];
    setValue(newValue);
    onSearch && onSearch(newValue);
  }, [value, onSearch, setValue]);

  if (withSuffixIcon) {
    return /*#__PURE__*/_jsx(Input.Search, _objectSpread(_objectSpread({
      withSuffixIcon: true,
      addonBefore: /*#__PURE__*/_jsx(Select, _objectSpread({
        options: options,
        onChange: onSelectChange,
        value: value[0]
      }, selectProps)),
      onChange: onInputChange,
      value: value[1],
      placeholder: placeholderIn || placeholder,
      onSearch: onInputSearch
    }, props), {}, {
      className: cs('icloud-ui-group-search', 'icloud-ui-group-input', props.className)
    }));
  }

  return /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
    addonBefore: /*#__PURE__*/_jsx(Select, _objectSpread({
      options: options,
      onChange: onSelectChange,
      value: value[0]
    }, selectProps)),
    value: value[1],
    placeholder: placeholderIn || placeholder,
    onChange: onInputChange
  }, props), {}, {
    className: cs('icloud-ui-group-input', props.className)
  }));
}

GroupInput.displayName = "GroupInput";

function GroupSearch(props) {
  return /*#__PURE__*/_jsx(GroupInput, _objectSpread({
    withSuffixIcon: true,
    allowClear: true
  }, props));
}

GroupSearch.displayName = "GroupSearch";
GroupInput.GroupSearch = GroupSearch;
export default GroupInput;
//# sourceMappingURL=es/index.js.map